export const approvalButtonsConfig = (
  actionHandler,
  verificationActionSettings,
  consentActionSettings,
  checkConsentStatus,
  checkVerificationStatus,
  showVerifyButton,
  showConsentButton,
  dontShowButtons,
  setSelectedRowForForm
) => [
  {
    label: consentActionSettings?.label,
    onClick: () => actionHandler(consentActionSettings),
    type: 'button',
    size: 'small',
    startIcon: <i className={`fas fa-check`} />,
    className: 'default-btn-primary',
    disabled: !checkConsentStatus,
    hidden: !showConsentButton || dontShowButtons || setSelectedRowForForm,
  },
  {
    label: verificationActionSettings?.label,
    onClick: () => actionHandler(verificationActionSettings),
    type: 'button',
    size: 'small',
    startIcon: <i className={`fas fa-check`} />,
    className: 'default-btn-primary',
    disabled: !checkVerificationStatus,
    hidden: !showVerifyButton || dontShowButtons || setSelectedRowForForm,
  },
];
